import { css } from "styled-components";
export default function stack({
  inline
}) {
  return !inline && css(["display:block;& + &{margin-top:10px;}"]);
}
//# sourceMappingURL=stack.js.map